import { LocalShippingOutlined } from '@mui/icons-material'
import { Tooltip, Typography } from '@mui/material'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { useTranslation } from 'react-i18next'
import { BoMItemActivityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppSelector } from 'store/configureStore'
import { makeStyles } from 'tss-react/mui'
import { ActivityArticleSelectorButton } from './ActivityArticleSelectorButton'
import ActivityTooltip from './ActivityTooltip'
import { BomItemActivityKeywordsInput } from './BomItemActivityKeywordsInput'

export type ActivityWithArticleProps = {
  bomItemPointer: BomItemPointer
  activity: BoMItemActivityDto
  keywordsInputVariant?: 'input' | 'button'
  dataTestId?: string
}

const useStyles = makeStyles({ name: 'AcitivityWithArticle' })((theme) => ({
  root: {
    width: '100%',
  },
  sameLine: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  },
}))

export function ActivityWithArticle(props: ActivityWithArticleProps) {
  const { classes } = useStyles()
  const { t } = useTranslation()

  const bomItemMaterialProvided = useAppSelector(
    projectSelectors.bomItemMaterialIsProvidedSelector(props.bomItemPointer),
  )

  if (!props.activity) return null

  return (
    <div className={classes.root}>
      <div className={classes.sameLine}>
        {props.activity?.primaryWorkingStep && (
          <ActivityTooltip
            bomItemPointer={props.bomItemPointer}
            bomItemActivity={props.activity}
            attributes={{
              width: '26px',
            }}
            dataTestId={
              props.dataTestId ? `${props.dataTestId}-icon` : undefined
            }
          />
        )}
        {props.keywordsInputVariant === 'button' ? (
          <ActivityArticleSelectorButton
            variant="materialView"
            activityId={props.activity.id}
            bomItemPointer={props.bomItemPointer}
            workingStepType={props.activity?.primaryWorkingStep}
          />
        ) : (
          <>
            <BomItemActivityKeywordsInput
              bomItemPointer={props.bomItemPointer}
              activityId={props.activity.id}
              disabled={props.bomItemPointer.type === BomItemType.partInstance}
              dataTestId={props.dataTestId}
            />
            {bomItemMaterialProvided && props.activity.usesRawMaterial && (
              <Tooltip
                title={t(
                  'project:material-provided-by-customer',
                  'material provided by customer',
                )}
              >
                <div>
                  <Typography color="textSecondary" component="span">
                    <LocalShippingOutlined />
                  </Typography>
                </div>
              </Tooltip>
            )}
            <ActivityArticleSelectorButton
              bomItemPointer={props.bomItemPointer}
              activityId={props.activity?.id}
              workingStepType={props.activity?.primaryWorkingStep}
              variant="partTypeView"
              disabled={props.bomItemPointer.type === BomItemType.partInstance}
            />
          </>
        )}
      </div>
    </div>
  )
}
